import React, { useEffect, useState } from "react";

import PropTypes from "prop-types";

import ChallengeLearnMoreModal from "@/challenges/ChallengeLearnMoreModal/ChallengeLearnMoreModal";

import useHasFeature from "@/features/useHasFeature";
import {
  challengesAmountOfTokensCss,
  challengesInfoTextCss,
} from "./ChallengeTokensInfoText.style";

const propTypes = {
  isStudent: PropTypes.bool,
  articleData: PropTypes.any,
};
const ChallengeTokensInfoText = ({ isStudent, articleData }) => {
  const [data, setData] = useState(articleData?.data || articleData);

  const [canViewGuidedHighlighting] = useHasFeature(
    "can_view_guided_highlighting",
  );

  useEffect(() => {
    setData(articleData?.data || articleData);
  }, [articleData]);

  return articleData && !articleData?.error_message ? (
    <span css={challengesInfoTextCss}>
      {isStudent
        ? canViewGuidedHighlighting
          ? "Complete the quiz, the Power Words and the Guided Highlighting activities to earn up to "
          : "Complete the quiz and the Power Words activities to earn up to "
        : canViewGuidedHighlighting
          ? "Students can complete the quiz, the Power Word and the Guided Highlighting activities to earn up to "
          : "Students can complete the quiz and the Power Word activities to earn up to "}
      <b css={challengesAmountOfTokensCss}>
        {data?.tokens + (canViewGuidedHighlighting ? 30 : 0)}
      </b>
      {" tokens. "}
      {isStudent && <ChallengeLearnMoreModal />}
    </span>
  ) : null;
};

ChallengeTokensInfoText.propTypes = propTypes;
export default ChallengeTokensInfoText;
